/* 🤖 this file was generated by svg-to-ts */
export const waytrSearch = {
    name: 'search',
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><path d="M7.81,7.83a.5.5,0,0,1,.7,0l1.27,1h0a.68.68,0,0,1,0,.94.65.65,0,0,1-.94,0L7.81,8.59l0-.05a.55.55,0,0,1-.12-.33A.55.55,0,0,1,7.81,7.83ZM4.29,0a4.26,4.26,0,0,1,3,1.27,4.34,4.34,0,0,1-3,7.4A4.31,4.31,0,0,1,0,4.33,4.31,4.31,0,0,1,4.29,0Z"/></svg>`,
};
